import { useState } from "react";
import { api } from "api";
import { descargarCierreInventarioExcel } from "../../../helpers/descargarCierreInventarioExcel";

const ENDPOINT = "prod_bodega_cierres_inventario";

export const DetalleCierreApi = () => {
    const [cargando, setCargando] = useState(false);

    const getCierre = async (id) => {
        try {
            setCargando(true);
            const response = await api.get(`${ENDPOINT}/${id}`);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    // reajustes que explican la diferencia del cierre; son pocos, así que se
    // traen todos de una vez
    const getReajustes = async (id) => {
        try {
            setCargando(true);

            const response = await api.get(
                "prod_bodega_reajustes_inventario/historial",
                { cierre_id: id, no_paginar: "true" },
            );

            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const descargarCierreExcel = async (cierre) => {
        try {
            setCargando(true);
            await descargarCierreInventarioExcel(cierre);
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    return {
        getCierre,
        getReajustes,
        descargarCierreExcel,

        cargando,
    };
};
